import { render } from "./AddTesti.vue?vue&type=template&id=7652f370"
import script from "./AddTesti.vue?vue&type=script&lang=js"
export * from "./AddTesti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__